export default __webpack_public_path__ + "static/media/logo-petal.8a41023e.svg";